import React from 'react';
import {Wrapper} from '@googlemaps/react-wrapper';
import MapStatus from './MapStatus';
import config from '../../../config';

const GOOGLE_MAPS_API_KEY = config.googleMapsApiKey;

const MapWrapper = (props) => (
    <Wrapper {...props} apiKey={GOOGLE_MAPS_API_KEY} render={MapStatus} />
);

export default MapWrapper;
